export default __webpack_public_path__ + "static/media/detail_mobile_13_3.150c7bfc.jpg";